// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export function deleteRule({ruleId, name}) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                type: 'DELETE_RULE_FULFILLED',
                response: jsonResponse || `${name} has been successfully deleted.`,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'DELETE_RULE_REJECTED',
                error,
            });
        };
        const actionParams = {
            servicesConfig: servicesFormConfig.deleteRule,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'DELETE_RULE',
        });

        return actionsServiceCaller(actionParams, {}, ruleId);
    };
}

export function deleteRuleReset() {
    return (dispatch) => {
        dispatch({
            type: 'DELETE_RULE_RESET',
        });
    };
}
